const Login = () => import("../components/loginView.vue");


/* Exporting the object routes of login module. */
export default [
  {
    name: "login",
    path: "/login",
    meta: {
      Title: "Login",
      layout: "NotLoggedLayout",
      requireAuth: false
    },
    component: Login,
  },
];